var carousel = {

	init: function () {
		$('.m-carousel .js-gallery:not(.js-gallery-done)').each(function () {
			var wrapper = $(this);

			// init slider
			wrapper.bxSlider({
				pager: false,
				speed: 500,
				minSlides: 1,
				maxSlides: 5,
				moveSlides: 1,
				slideWidth: 192,
				slideMargin: 10
			});
			
			// done
			wrapper.addClass('js-gallery-done');
		});
	}

};

$(function () {
	carousel.init();
	site.doc.ajaxComplete(function () {
		carousel.init();
	});
});